import React from 'react';

function PhoneFrame({ children, className, style }) {
  return (
    <div className={`phone-frame ${className || ''}`} style={style}>
      <div className="phone-frame__inner">
        <div className="phone-frame__dynamic-island"></div>
        <div className="phone-frame__screen">
          {children}
        </div>
        <div className="phone-frame__home-bar"></div>
      </div>
    </div>
  );
}

export default PhoneFrame;
